import { AUTH, PRESCREENING, ROUTE } from '@/constants';
import { loadView } from '../index';

const ExchangeBuyView = loadView('exchange/ExchangeBuyView');
const ExchangeDashboardView = loadView('exchange/ExchangeDashboardView');
const ExchangeDetailView = loadView('exchange/ExchangeDetailView');
const ExchangeSellView = loadView('exchange/ExchangeSellView');

const exchangeRoute = {
  path: ROUTE.PATH.EXCHANGE,
  component: () => import('@/layouts/default/DefaultLayout.vue'),
  meta: {
    auth: AUTH.USER_ROLE.AUTHORIZED,
    tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
  },
  children: [
    {
      path: '',
      name: ROUTE.NAME.EXCHANGE,
      component: ExchangeDashboardView,
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
      },
    },
    {
      path: `${ROUTE.PATH.EXCHANGE_BUY}/:wallet`,
      name: ROUTE.NAME.EXCHANGE_BUY,
      component: ExchangeBuyView,
      props: (route) => ({ ...route.params }),
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
      },
    },
    {
      path: ROUTE.PATH.EXCHANGE_DASHBOARD,
      name: ROUTE.NAME.EXCHANGE_DASHBOARD,
      component: ExchangeDashboardView,
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
      },
    },
    {
      path: `${ROUTE.PATH.EXCHANGE_DETAIL}/:wallet`,
      name: ROUTE.NAME.EXCHANGE_DETAIL,
      component: ExchangeDetailView,
      props: (route) => ({ ...route.params, ...route.query }),
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
      },
    },
    {
      path: `${ROUTE.PATH.EXCHANGE_SELL}/:wallet`,
      name: ROUTE.NAME.EXCHANGE_SELL,
      component: ExchangeSellView,
      props: (route) => ({ ...route.params }),
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
      },
    },
  ],
};

export default exchangeRoute;
